import styled from '@emotion/styled';
import { mainColors, automaticWithdrawalColors } from 'src/assets/colors';

interface FilterPropsType {
    isActive?: boolean,
}

export const Filter = styled('button', { label: 'Filter' }) <FilterPropsType>`
    background: ${({ isActive }): string => isActive ? automaticWithdrawalColors.buttonFilterColor : 'transparent'};
    border-radius: 50vh;
    border: 2px solid ${automaticWithdrawalColors.buttonFilterColor};
    cursor: pointer;
    color: ${({ isActive }): string => isActive ? mainColors.default.light : automaticWithdrawalColors.buttonFilterColor};
    font-size: 12px;
    font-weight: bold;
    margin: 0 8px 0 0;
    line-height: 1;
    outline: none;
    padding: 5px 8px;
`;
